import React from 'react';
import { NavigationMenu, NavigationMenuContent, NavigationMenuIndicator, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuTrigger, navigationMenuTriggerStyle } from '@zep/ui/experimental';
import { cn, getResizedImage } from '@zep/utils';
import { GNBMenu } from '../../../types';
import { ServiceMenuIcon } from './ServiceMenuIcon';
export const GlobalNavigationBarMenu = (props: GNBMenuProps) => {
  const {
    headerContent
  } = props;
  const navigationBarRef = React.useRef<React.ElementRef<typeof NavigationMenu>>(null);
  const handleTriggerHover = (event: React.MouseEvent<HTMLButtonElement>) => {
    const trigger = event.currentTarget;
    const menu = navigationBarRef.current;
    if (menu && trigger) {
      const triggerRect = trigger.getBoundingClientRect();
      const menuRect = menu.getBoundingClientRect();
      const position = triggerRect.left - menuRect.left;
      menu.style.setProperty('--radix-navigation-menu-content-position', `${position}px`);
    }
  };
  return <NavigationMenu ref={navigationBarRef} data-sentry-element="NavigationMenu" data-sentry-component="GlobalNavigationBarMenu" data-sentry-source-file="GlobalNavigationBarMenu.tsx">
      <NavigationMenuList data-sentry-element="NavigationMenuList" data-sentry-source-file="GlobalNavigationBarMenu.tsx">
        {headerContent.map(menu => <NavigationMenuItem key={menu.title}>
            {menu.menus && menu.menus.length > 0 ? <>
                <NavigationMenuTrigger onMouseEnter={handleTriggerHover} className={cn('text-[14px] font-[600] text-gray-900', 'data-[active]:bg-[#27262E14] data-[state=open]:bg-[#27262E14]', 'hover:bg-[#27262E14] hover:text-[#27262E]', 'focus:bg-[#27262E14] focus:text-[#27262E]')}>
                  {menu.title}
                </NavigationMenuTrigger>
                <NavigationMenuContent>
                  <ul className={cn('grid grid-cols-1 w-[240px] gap-x-[12px] gap-y-[6px] p-[18px] rounded-[8px]',
            // 소개 탭일 때 width 조정
            {
              'w-[321px]': menu.isWide,
              'w-[200px]': menu.variant === 'service'
            })}>
                    {menu.menus.filter(subMenu => !subMenu.hidden).map(subMenu => <NavigationSubMenuItem key={subMenu.name} title={subMenu.name} iconUrl={subMenu.icon} href={subMenu.url} description={subMenu?.description} isService={menu.variant === 'service'} aria-label={subMenu.newTabLabel ? `${subMenu.name} (${subMenu.newTabLabel})` : undefined} target={menu.variant === 'service' ? subMenu.target : undefined} />)}
                  </ul>
                </NavigationMenuContent>
              </> : <NavigationMenuLink className={cn(navigationMenuTriggerStyle(), 'text-[14px] font-[600] text-gray-900', 'hover:bg-[#27262E14] hover:text-[#27262E]', 'focus:bg-[#27262E14] focus:text-[#27262E]')} href={menu.path}>
                {menu.title}
              </NavigationMenuLink>}
          </NavigationMenuItem>)}
        <NavigationMenuIndicator data-sentry-element="NavigationMenuIndicator" data-sentry-source-file="GlobalNavigationBarMenu.tsx" />
      </NavigationMenuList>
    </NavigationMenu>;
};
const NavigationSubMenuItem = React.forwardRef<React.ElementRef<'a'>, React.ComponentPropsWithoutRef<'a'> & {
  title: string;
  iconUrl?: string;
  description?: string;
  isService?: boolean;
}>(({
  className,
  title,
  iconUrl,
  description,
  isService,
  ...props
}, ref) => {
  return <li>
      <NavigationMenuLink asChild>
        <a ref={ref} className={cn('block select-none rounded-[6px] px-[12px] pt-[12px] pb-[10px] leading-none no-underline outline-none transition-colors', 'hover:bg-gray-50', 'focus:bg-gray-50', isService && 'text-default', className)} rel={props.target === '_blank' ? 'noopener noreferrer' : undefined} {...props}>
          <div className={cn('flex items-start gap-[10px]', isService && 'items-center text-body-md-medium')}>
            {isService ? <span className="shrink-0 p-[2px]" aria-hidden="true">
                <ServiceMenuIcon name={title} />
              </span> : iconUrl ? <img width={24} height={24} src={getResizedImage(iconUrl, 24)} alt="icon" /> : null}
            {isService ? title : <div className="flex flex-col justify-start gap-[4px]">
                <div className="pt-[2px] text-body-1 font-[700] text-gray-900">
                  {title}
                </div>
                {description && <p className="line-clamp-2 text-body-1 font-[500] text-[#27262EA3]">
                    {description}
                  </p>}
              </div>}
          </div>
        </a>
      </NavigationMenuLink>
    </li>;
});
NavigationSubMenuItem.displayName = 'NavigationSubMenuItem';
type GNBMenuProps = {
  headerContent: GNBMenu[];
};